<template>
  <div id="publicDisplay" class="page-wrap">
    <div class="image-wrap">
      <div v-if="socialStatus.imageStatus == false" class="image-null">
        <i class="fa fa-user" id="user" aria-hidden="true"></i>
      </div>
      <div v-else class="image-container" id="displayImg">
        <img class="image-profile" :src="profile.imageUri" alt="">
      </div>
      <div class="image-icon"> 
        <div class="image-wrap">
          <a id="displayPhoneIcon" @click="phoneCall">
            <img class="image-call" src="../../src/assets/call_1.png" alt="positionIcon" height="15">
          </a>
          <a id="displayEmailIcon" @click="sendMail">
            <img class="image-call" src="../../src/assets/mail.png" alt="positionIcon" height="15">
          </a>
        </div>
      </div>
    </div>
    <div>
      <div class="text-container" id="displayProfile">
        <p id="displayName" class="profile-name">{{ profile.contactName }}</p>
        <p id="displayNickname" class="profile-nickname">{{ profile.nickName }}</p>
        <p id="displayMe" class="profile-me">{{ profile.aboutMe }}</p>
      </div>
    </div>
    <div class="hr-line" id="displayHorizontalLine">
      <hr class="black-line">
    </div>
    <div class="icon-row">
      <div class="icon-col50">
        <div class="col-left" id="displayPosition">
          <div class="icon-contain">
            <div class="icon-contain-image">
              <img class="icon-image" src="../../src/assets/position.png" alt="positionIcon" height="15">
            </div>
            <div class="icon-contain-text">
              <p class="icon-text">Position</p>
            </div>
          </div>
          <p class="profile-text">{{ profile.position }}</p>
        </div>
      </div>
      <div class="icon-col50">
        <div class="col-right" id="displayOrg">
          <div class="icon-contain">
            <div class="icon-contain-image">
              <img class="icon-image" src="../../src/assets/organization.png" alt="orgIcon" height="15">
            </div>
            <div class="icon-contain-text">
              <p class="icon-text">Organization</p>
            </div>
          </div>
          <p class="profile-text">{{ profile.organization }}</p>
        </div>
      </div>
    </div>
    <div class="contact-wrap" id="displayContact">
      <div class="contact-contain" id="displayEmail">
        <div class="contact-icon">
          <img class="icon-email" src="../../src/assets/email.png" alt="emailIcon" height="15">
        </div>
        <div class="contact-head">
          <p class="contact-text">Email</p>
        </div>
        <div class="contact-data">
          <p class="contact-info">{{ profile.email }}</p>
        </div>
      </div>
      <div class="contact-contain" id="displayPhone">
        <div class="contact-icon">
          <img class="icon-image" src="../../src/assets/call.png" alt="phoneIcon" height="15">
        </div>
        <div class="contact-head">
          <p class="contact-text">Mobile Phone</p>
        </div>
        <div class="contact-data">
          <p class="contact-info">{{ profile.mobilePhone }}</p>
        </div>
      </div>
      <a class="contact-contain" id="displayWeb"
        @click="openWebsite">
        <div class="contact-icon">
          <img class="icon-image" src="../../src/assets/website.png" alt="webIcon" height="15">
        </div>
        <div class="contact-head">
          <a class="contact-text">Website</a>
        </div>
        <div class="contact-data">
          <a class="contact-info">{{ profile.website }}</a>
        </div>
      </a>
    </div>
    <p class="social-text" id="displayText">Follow me on :</p>
    <div class="social-container" id="displaySocial">
      <div class="social-block" v-if="this.socialStatus.linkedinStatus == true">
        <a @click="openLinkedIn" id="displayLinkedIn">
          <fa-icon id="linkedInIcon" class="social-icon-linkin" icon="fa-brands fa-linkedin-in"/>
        </a>
      </div>
      <div class="social-block" v-if="this.socialStatus.facebookStatus == true">
        <a @click="openFacebook" id="displayFacebook">
          <fa-icon id="facebookIcon" class="social-icon-facebook" icon="fa-brands fa-facebook"/>
        </a>
      </div>
      <div class="social-block" v-if="this.socialStatus.igStatus == true">
        <a @click="openIg" id="displayIg">
          <fa-icon id="igIcon" class="social-icon-ig" icon="fa-brands fa-instagram"/>
        </a>
      </div>
      <div class="social-block" v-if="this.socialStatus.twitterStatus == true">
        <a @click="openTwitter" id="displayTwitter">
          <fa-icon id="twitterIcon" class="social-icon-twitter" icon="fa-brands fa-twitter"/>
        </a>
      </div>
      <div class="social-block" v-if="this.socialStatus.lineStatus == true">
        <a @click="openLine" id="displayLine">
          <img src="../../src/assets/social_line.png" class="social-icon-line" alt="igIcon">
        </a>
      </div>
      <div class="social-block" v-if="this.socialStatus.wechatStatus == true">
        <a @click="openWeChat" id="displayWeChat">
          <fa-icon id="wechatIcon" class="social-icon-wechat" icon="fa-brands fa-weixin"/>
        </a>
      </div>
      <div class="social-block" v-if="this.socialStatus.whatsappStatus == true">
        <a @click="openWhatsApp" id="displayWhatsApp">
          <fa-icon id="whatsappIcon" class="social-icon-whatsapp" icon="fa-brands fa-whatsapp"/>
        </a>
      </div>
      <div class="social-block" v-if="this.socialStatus.kakaoStatus == true">
        <a @click="openKakao" id="displayKakao">
          <img src="../../src/assets/social_kakao.png" class="social-icon-kakao" alt="igIcon">
        </a>
      </div>
    </div>
    <div class="btn-wrap" @click="dialog_vcard" id="displayVcard">
      <div class="btn-contact">
        <a>Get Contact</a>
      </div>
    </div>
  </div>
</template>

<script>
import actions from '../store/user/actions.js'
import swal from 'sweetalert2';

export default {
  name: 'PublicPage',
  data() {
    return {
      vcard_link: '',
      status: null,
      image: null,
      mailTo: '',
      countSocial: 0,
      socialStatus: {
        "linkedinStatus": false,
        "facebookStatus": false,
        "igStatus": false,
        "twitterStatus": false,
        "webStatus": false,
        "imageStatus": "",
        "lineStatus": false,
        "wechatStatus": false,
        "whatsappStatus": false,
        "kakaoStatus": false,
      },
      profile: {
        "firstName": "",
        "lastName": "",
        "contactName": "",
        "nickName": "",
        "aboutMe": "",
        "position": "",
        "organization": "",
        "email": "",
        "mobilePhone": "",
        "website": "",
        "linkedin": "",
        "facebook": "",
        "ig": "",
        "twitter": "",
        "line": "",
        "wechat": "",
        "whatsapp": "",
        "kakao": "",
        "imageUri": "",
        "vcard": "",
      },
      objFromUrl: {
        "cipherText": "",
        "userId": "",
      },
    };
  },
  watch: {
    contact_name: function (val) {
      if (val != null) {
        this.dialog_vcard()
      }
    }
  },
  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.objFromUrl.cipherText = urlParams.get('cpt');
  },
  mounted() {
    if (this.objFromUrl.cipherText != null) {
      this.displayUser();
    } else {
      // this.redirect();
    }
  },
  methods: {
    getContact() {
      var json_obj = JSON.stringify({
        eid: this.objFromUrl.userId,
        mode: "SIC43NT",
        cpt: this.objFromUrl.cipherText
      })
      var xmlhttp = new XMLHttpRequest();
      var theUrl = "https://sicbizcard.azurewebsites.net/api/DynamicNdefBizCard?code=j8mXkslopVIH3v156tVzObNvGntp82NVwrBb8dZZ7mR6AzFudznwjg==";
      xmlhttp.open("POST", theUrl);
      xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xmlhttp.setRequestHeader("Accept", "application/json, text/plain, */*");
      xmlhttp.onload = () => {
        var response = JSON.parse(xmlhttp.responseText);
        this.status = response.status;
        if (response.status == "LOAD SUCCESS") {
          this.contact_name = response.en.firstName + " " + response.en.lastName;
          this.position = response.en.title;
          this.image = response.profilePicAddr;
          this.v_card = response.vCardAddr;
        }
      }
      xmlhttp.onreadystatechange = () => {
        if (xmlhttp.status != 200) {
          this.status = 'data from name card is incorrect.';
        }
      }
      xmlhttp.send(json_obj);
    },
    dialog_vcard() {
      this.vcard_link = this.profile.vcard;
      window.open(this.vcard_link, '_blank', 'noopener,noreferrer');
    },
    redirect() {
      setTimeout(function () {
        if (this.status != "LOAD SUCCESS") {
          location.replace("https://www.sic.co.th")
        }
      }, 5000);
    },
    sendMail() {
      const mailto = "mailto:" + this.profile.email;
      window.open(mailto, '_blank', 'noopener,noreferrer');
    },
    phoneCall() {
      const tel = "tel:" + this.profile.mobilePhone;
      window.open(tel, '_blank', 'noopener,noreferrer');
    },
    openLinkedIn() {
      if(this.socialStatus.linkedinStatus == true)
      {
        const linkedin = this.profile.linkedin;
        window.open(linkedin, '_blank', 'noopener,noreferrer');
      }
    },
    openFacebook() {
      const facebook = this.profile.facebook;
      window.open(facebook, '_blank', 'noopener,noreferrer');
    },
    openIg() {
      const ig = this.profile.ig;
      window.open(ig, '_blank', 'noopener,noreferrer');
    },
    openTwitter() {
      const twitter = this.profile.twitter;
      window.open(twitter, '_blank', 'noopener,noreferrer');
    },
    openLine() {
      const line = this.profile.line;
      window.open(line, '_blank', 'noopener,noreferrer');
    },
    openWhatsApp() {
      const whatsApp = this.profile.whatsapp;
      window.open(whatsApp, '_blank', 'noopener,noreferrer');
    },
    openWeChat() {
      // const weChat = this.profile.wechat;
      // window.open(weChat, '_blank', 'noopener,noreferrer');
      swal.fire({   
        title: 'Account/Mobile No:',
        text: this.profile.wechat, 
        showCancelButton: true,   
        confirmButtonColor: "#3cd2ef",
        confirmButtonText: '<i class="fa fa-copy"></i> Copy',
        // closeOnConfirm: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          navigator.clipboard.writeText(this.profile.wechat);
        }
      })
    },
    openKakao() {
      const kakao = this.profile.kakao;
      window.open(kakao, '_blank', 'noopener,noreferrer');
    },
    openWebsite() {
      if(this.socialStatus.webStatus == true)
      {
        var webLink = this.profile.website;
        let resultHttp = webLink.includes("http://");
        let resultHttps = webLink.includes("https://");
        if((resultHttp == true) || (resultHttps == true))
        {
          webLink = this.profile.website;
        }
        else 
        {
          webLink = "//" + this.profile.website;
        }
        
        const website = webLink;
        window.open(website, '_blank', 'noopener,noreferrer');
      }
    },
    displayUser (){    
      var sicBizCardInfo = actions.checkUserResult.user;
      if(sicBizCardInfo != null)
      {
        document.getElementById("publicDisplay").style.visibility = "visible"; 
        
        if((sicBizCardInfo.ImageUri == null) || (sicBizCardInfo.ImageUri == ""))
        {
          this.socialStatus.imageStatus = false;
        }
        else
        {
          this.socialStatus.imageStatus = true;
          this.profile.imageUri = sicBizCardInfo.ImageUri;
        }

        if((sicBizCardInfo.Firstname == null) || (sicBizCardInfo.Firstname == ""))
        {
          this.profile.contactName = "";
        }
        else
        {
          this.profile.firstName = sicBizCardInfo.Firstname;
          this.profile.contactName = this.profile.firstName + " ";
        }

        if((sicBizCardInfo.Lastname == null) || (sicBizCardInfo.Lastname == ""))
        {
          this.profile.contactName += "";
        }
        else
        {
          this.profile.lastName = sicBizCardInfo.Lastname;	
          this.profile.contactName += this.profile.lastName;
        }

        if((sicBizCardInfo.Nickname == null) || (sicBizCardInfo.Nickname == ""))
        {
          this.profile.nickName = "";
        }
        else
        {
          this.profile.nickName = "( " + sicBizCardInfo.Nickname + " )";
        }

        if((sicBizCardInfo.AboutMe == null) || (sicBizCardInfo.AboutMe == ""))
        {
          document.getElementById("displayMe").style.padding = "1vw"; 
        }
        else
        {
          this.profile.aboutMe = sicBizCardInfo.AboutMe;
        }

        if((sicBizCardInfo.JobTitle == null) || (sicBizCardInfo.JobTitle == ""))
        {
          this.profile.position = "-";
        }
        else
        {
          this.profile.position = sicBizCardInfo.JobTitle;
        }

        if((sicBizCardInfo.Organization == null) || (sicBizCardInfo.Organization == ""))
        {
          this.profile.organization = "-";
        }
        else
        {
          this.profile.organization = sicBizCardInfo.Organization;
        }

        if((sicBizCardInfo.Email == null) || (sicBizCardInfo.Email == ""))
        {
          document.getElementById("displayEmailIcon").style.display = "none";
          this.profile.email = "-";
        }
        else
        {
          this.profile.email = sicBizCardInfo.Email; 
        }

        if((sicBizCardInfo.Mobile == null) || (sicBizCardInfo.Mobile == ""))
        {
          document.getElementById("displayPhoneIcon").style.display = "none";
          this.profile.mobilePhone = "-";
        }
        else
        {
          this.profile.mobilePhone = sicBizCardInfo.Mobile;
        }

        if((sicBizCardInfo.Website == null) || (sicBizCardInfo.Website == ""))
        {
          this.profile.website = "-";
          this.socialStatus.webStatus = false;

        }
        else
        {
          this.socialStatus.webStatus = true;
          this.profile.website = sicBizCardInfo.Website;
        }

        if((sicBizCardInfo.LinkedIn == null) || (sicBizCardInfo.LinkedIn == ""))
        {
          this.socialStatus.linkedinStatus = false;
        }
        else
        {
          this.profile.linkedin = sicBizCardInfo.LinkedIn;
          this.socialStatus.linkedinStatus = true;
        }

        if((sicBizCardInfo.Facebook == null) || (sicBizCardInfo.Facebook == ""))
        {
          this.socialStatus.facebookStatus = false;
        }
        else
        {
          this.profile.facebook = sicBizCardInfo.Facebook;
          this.socialStatus.facebookStatus = true;
        }

        if((sicBizCardInfo.Instagram == null) || (sicBizCardInfo.Instagram == ""))
        {
          this.socialStatus.igStatus = false;
        }
        else
        {
          this.profile.ig = sicBizCardInfo.Instagram;
          this.socialStatus.igStatus = true;
        }

        if((sicBizCardInfo.Twitter == null) || (sicBizCardInfo.Twitter == ""))
        {
          this.socialStatus.twitterStatus = false;
        }
        else
        {
          this.profile.twitter = sicBizCardInfo.Twitter;
          this.socialStatus.twitterStatus = true;
        }

        if((sicBizCardInfo.Line == null) || (sicBizCardInfo.Line == ""))
        {
          this.socialStatus.lineStatus = false;
        }
        else
        {
          this.profile.line = "http://line.me/ti/p/~" + sicBizCardInfo.Line;
          this.socialStatus.lineStatus = true;
        }

        if((sicBizCardInfo.WeChat == null) || (sicBizCardInfo.WeChat == ""))
        {
          this.socialStatus.wechatStatus = false;
        }
        else
        {
          this.profile.wechat = sicBizCardInfo.WeChat;
          this.socialStatus.wechatStatus = true;
        }

        if((sicBizCardInfo.WhatsApp == null) || (sicBizCardInfo.WhatsApp == ""))
        {
          this.socialStatus.whatsappStatus = false;
        }
        else
        {
          this.profile.whatsapp = "https://wa.me/" + sicBizCardInfo.WhatsApp;
          this.socialStatus.whatsappStatus = true;
        }

        if((sicBizCardInfo.Kakao == null) || (sicBizCardInfo.Kakao == ""))
        {
          this.socialStatus.kakaoStatus = false;
        }
        else
        {
          this.profile.kakao = sicBizCardInfo.Kakao;
          this.socialStatus.kakaoStatus = true;
        }

        if(((sicBizCardInfo.LinkedIn == null) || (sicBizCardInfo.LinkedIn == "")) && ((sicBizCardInfo.Facebook == null) || (sicBizCardInfo.Facebook == "")) && 
        ((sicBizCardInfo.Instagram == null) || (sicBizCardInfo.Instagram == "")) && ((sicBizCardInfo.Twitter == null) || (sicBizCardInfo.Twitter == "")) && 
        ((sicBizCardInfo.Line == null) || (sicBizCardInfo.Line == "")) && ((sicBizCardInfo.WeChat == null) || (sicBizCardInfo.WeChat == "")) && 
        ((sicBizCardInfo.WhatsApp == null) || (sicBizCardInfo.WhatsApp == "")  && ((sicBizCardInfo.Kakao == null) || (sicBizCardInfo.Kakao == "")))) {
          document.getElementById("displayText").style.display = "none";
          // document.getElementById("linkedInIcon").style.display = "none";
          // document.getElementById("facebookIcon").style.display = "none";
          // document.getElementById("igIcon").style.display = "none";
          // document.getElementById("twitterIcon").style.display = "none";
          // document.getElementById("lineIcon").style.display = "none";
          // document.getElementById("wechatIcon").style.display = "none";
          // document.getElementById("whatsappIcon").style.display = "none";
          // document.getElementById("kakaoIcon").style.display = "none";
          document.getElementById("displaySocial").style.display = "none";

        }

        if((sicBizCardInfo.VcardUri == null) || (sicBizCardInfo.VcardUri == "null"))
        {
          document.getElementById("displayVcard").style.visibility = "hidden";
          document.getElementById("displayVcard").style.height = "11vw";
          document.getElementById("displaySocial").style.marginBottom = "3.5rem";
        }
        else
        {
          this.profile.vcard = sicBizCardInfo.VcardUri;
        }
      }
    },
  },
  
}
</script>

<style>
.page-wrap {
  height: 100%;
  width: 100%;
  visibility: hidden;
}
.image-wrap {
  position: relative;
  padding-top: 1.2rem;
  width: 100%;
}
.image-null {
  border: 2px solid rgba(58, 58, 58, 0.596);
  width: 90%;
  position: relative;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  background-color: rgb(226, 226, 226);
}
#user {
  background: linear-gradient(45deg, #3cd2ef 0%, #3c9bef 100%);
  -webkit-background-clip: text;
          /* Also define standard property for compatibility */
          background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 14rem; /* change this to change the size*/
}
.image-container {
  position: relative;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  background-color: white;
}
.image-profile {
  max-width: 90%;
  background-color: white;
}
.image-icon {
  position: absolute;
  right: 0;
  margin-right: 8%;
  margin-top: -11%;
}
.image-call {
  height: 10vw;
  margin-left: 3vw;
  vertical-align: middle;
}
.image-social {
  height: 10vw;
  margin-left: 3vw;
  vertical-align: middle;
}
.text-container {
  text-align: center;
  margin-top: 9vw;
}
.profile-name {
  font-size: 6vw;
  color: black;
  overflow-wrap: break-word;
}
.profile-nickname {
  font-size: 5vw;
  margin-top: 1rem; 
  margin-bottom: 0.2rem;
  color: #3cd2ef;
  overflow-wrap: break-word;
}
.profile-me {
  padding: 1rem; 
  font-size: 3vw;
  overflow-wrap: break-word;
}
.profile-text {
  font-size: 0.9rem;
  margin-top: 0.5rem;
  overflow-wrap: break-word;
}
.black-line {
  width: 100%;
  border: 1px solid black;
}
.hr-line {
  margin: 0;
  position: relative;
  padding: 0;
  bottom: 0;
  left: 50%;
  width: 95%;
  text-align: center;
  overflow: hidden;
  transform: translate(-50%, 0%);
}
.icon-row {
  display: table;
  width: 100%; 
  table-layout: fixed; 
  margin-top: 1rem;
}
.icon-col50 {
  display: table-cell;
  width: 50%;
  margin: 0;
}
.col-left {
  margin-left: 7vw;
  padding-top: 3%;
  padding-bottom: 3%;
}
.col-right {
  margin-right: 5vw;
  margin-left: -0.2em;
  border-left: 1.4px solid rgb(92, 90, 90);;
  padding-left: 3vw;
  padding-top: 3%;
  padding-bottom: 3%;
}
.icon-contain {
  content: "";
  display: table;
  clear: both;
  width: 100%;
}
.icon-contain-image {
  float: left;
  width: 18%;
}
.icon-contain-text {
  float: left;
  width: 80%;
}
.icon-image {
  height: 1.2rem;
}
.icon-email {
  margin-right: 0.9rem;
  height: 0.9rem;
}
.icon-text {
  color: rgb(178, 178, 179);
  font-size: 1rem;

}
.contact-text {
  font-size: 0.9rem;
  color: black;
}
.contact-info {
  font-size: 0.9rem;
  margin-top: 0.5%;
  overflow-wrap: break-word;
}
.contact-wrap {
  margin-left: 7vw;
  margin-right: 7vw;
  margin-top: 5.3vh;
  margin-bottom: 5vh;
}
.contact-contain {
  content: "";
  display: table;
  clear: both;
  width: 100%;
  margin-top: 4vw;
}
.contact-icon {
  float: left;
  width: 10%;
}
.contact-head {
  float: left;
  width: 34%;
}
.contact-data {
  float: left;
  width: 56%;
}
.btn-wrap {
  height: 38vw;
}
.btn-contact {
  margin: auto;
  max-width: 35%;
  padding: 0.9rem 0.2rem;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: bold;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  border-radius: 10px;
  background-image: linear-gradient(to right, #3cd2ef 0%, #3c9bef 51%, #3c9bef 80%);
}
.btn-contact:hover {
  background-position: right center; /* change the direction of the change here */
  background-image: linear-gradient(to right, #3c9bef 0%, #3c9bef 51%, #3cd2ef 100%);
}
.social-text {
  color: rgb(178, 178, 179);
  text-align: center;
  font-size: 0.9rem;
  margin-top: 8vw;
  margin-bottom: 1rem;
}
.social-container {
  width: 65%;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 3vw;
}
.social-block {
  margin: 0 0.5rem 0.8rem 0.5rem;
  display: inline-block;
  width: 18%;
}
.social-icon {
  color: white;
  background: rgb(45, 45, 45);
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 2vw;
  /* margin-left: 3vw; */
  width: 6vw;
  height: 6vw;
}
.social-icon-facebook {
  color: #1778F2;
  /* background: #4267B2; */
  background: white;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  /* padding: 2vw; */
  /* margin-left: 4.5vw; */
  width: 10.3vw;
  height: 10.3vw;
}
.social-icon-ig {
  background: radial-gradient(circle farthest-corner at 35% 90%, rgb(255, 214, 0), transparent 50%), 
  radial-gradient(circle farthest-corner at 0 210%, rgb(255, 122, 0), transparent 50%), 
  radial-gradient(ellipse farthest-corner at 0 -25%, rgb(118, 56, 250), transparent 50%), 
  radial-gradient(ellipse farthest-corner at 20% -70%, rgb(118, 56, 250), transparent 50%), 
  radial-gradient(ellipse farthest-corner at 100% 0, rgb(211, 0, 197), transparent 50%), 
  radial-gradient(ellipse farthest-corner at 60% -20%, rgb(211, 0, 197), transparent 50%), 
  radial-gradient(ellipse farthest-corner at 100% 100%, rgb(255, 0, 105), transparent), 
  linear-gradient(rgb(118, 56, 250), rgb(211, 0, 197) 30%, rgb(255, 0, 105) 50%, rgb(255, 122, 0) 70%, rgb(255, 214, 0) 100%);
  -webkit-text-fill-color: transparent;
  color: white;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 1.4vw;
  /* margin-left: 4.5vw; */
  width: 7.2vw;
  height: 7.2vw;
  stroke: white;
  stroke-width: 10px;
}
.social-icon-linkin {
  color: white;
  background: #0072b1;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 2vw;
  /* margin-left: 4.5vw; */
  width: 6vw;
  height: 6vw;
}
.social-icon-line {
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  /* padding: 2vw; */
  /* margin-left: 4.5vw; */
  width: 10vw;
  height: 10vw;
}
.social-icon-kakao {
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  /* padding: 2vw; */
  /* margin-left: 4.5vw; */
  width: 10vw;
  height: 10vw;
}
.social-icon-twitter {
  color: white;
  background: #1DA1F2;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 2vw;
  /* margin-left: 4.5vw; */
  width: 6vw;
  height: 6vw;
}
.social-icon-wechat {
  color: white;
  background: #09B83E;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 1.5vw;
  /* margin-left: 4.5vw; */
  width: 7vw;
  height: 7vw;
}
.social-icon-whatsapp {
  color: white;
  background: #25d366;
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 1.5vw;
  /* margin-left: 4.5vw; */
  width: 7vw;
  height: 7vw;
}
.social-icon-phone {
  color: rgb(45, 45, 45);
  stroke: white;
  stroke-width: 50px;
  background: rgb(45, 45, 45);
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 2vw;
  margin-left: 3vw;
  width: 6vw;
  height: 6vw;
}
.social-icon-email {
  color: white;
  background: rgb(45, 45, 45);
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  padding: 2vw;
  margin-left: 3vw;
  width: 6vw;
  height: 6vw;
  font-size: 1px;
}
.swal2-title {
  font-size: 1.4em !important;
  color: #051c44 !important;
}
.my-actions { 
  margin-top: 1em;
  float: left;
  margin-right: 1rem;
}
.order-1 { 
  order: 1; 
}
.order-2 {
  order: 2; 
}
.right-gap {
  margin-right: auto;
}
@media screen and (min-width: 380px) {
  .social-container {
    width: 60%;
  }
}
@media screen and (max-width: 290px) {
  .btn-wrap {
    height: 50vw;
  }
  .btn-contact {
    font-size: 0.8rem;
    padding: 0.9rem 0.5rem;
  }
}
@media screen and (min-width: 550px) {
  .btn-wrap {
    height: 20vw;
  }
  .image-call {
    height: 3rem;
  }
  .image-icon {
    margin-right: 10%;
    margin-top: -3.5rem;
  }
  .icon-email {
    height: 1.3rem;
  }
  .icon-image {
    height: 1.8rem;
  }
  .social-icon {
    width: 2vw;
    height: 2vw;
  }
  .social-text {
    margin-bottom: 2rem;
  }
  .social-icon-facebook {
    width: 3.25rem;
    height: 3.25rem;
    /* padding: 0.6rem; */
  }
  .social-icon-ig {
    width: 2.3rem;
    height: 2.3rem;
    padding: 0.45rem;
  }
  .social-icon-linkin {
    width: 2rem;
    height: 2rem;
    padding: 0.6rem;
  }
  .social-icon-twitter {
    width: 2rem;
    height: 2rem;
    padding: 0.6rem;
  }
  .social-icon-line {
    width: 3.2rem;
    height: 3.2rem;
  }
  .social-icon-wechat {
    width: 2.2rem;
    height: 2.2rem;
    padding: 0.5rem;
  }
  .social-icon-whatsapp {
    width: 2.2rem;
    height: 2.2rem;
    padding: 0.5rem;
  }
  .social-icon-kakao {
    width: 3.2rem;
    height: 3.2rem;
  }
  .image-social {
    height: 6vw;
  }
  .social-text {
    font-size: 1.1rem;
    margin-top: 3rem;
  }
  .profile-me {
    font-size: 1.4rem;
    padding: 1.5rem;
  }
  .profile-name {
    font-size: 2.3rem;
  }
  .profile-nickname {
    font-size: 1.9rem;
  }
  .icon-text {
    font-size: 1.4rem;
  }
  .profile-text {
    font-size: 1.2rem;
    margin-top: 3vh;
  }
  .contact-wrap {
    margin-top: 3rem;
  }
  .contact-text {
    font-size: 1.4rem;
  }
  .contact-info {
    font-size: 1.2rem;
  }
  .btn-contact {
    font-size: 1.3rem;
    max-width: 15rem;
  }
  .text-container {
    margin-top: 5vh;
  }
  .contact-contain {
    margin-top: 1.5rem;
  }
  .icon-row {
    margin-top: 2rem;
  }
  .image-container {
    border: 1px solid rgba(89, 84, 84, 0.596);
    width: 90%;
  }
  .image-wrap {
    padding-top: 2rem;
  }
  .image-profile {
    margin-top: 0.3rem;
  }
  .contact-icon {
    width: 8%;
  }
  .contact-head {
    width: 30%;
  }
  .contact-data {
    width: 60%;
  }
  .icon-contain-image {
    width: 15%;
  }
  .icon-contain-text {
    width: 80%;
  }
}
@media screen and (min-width: 1000px) {
  .image-call {
    height: 4rem;
  }
  .social-icon-facebook {
    width: 3.9rem;
    height: 3.9rem;
  }
  .social-icon-ig {
    width: 2.6rem;
    height: 2.6rem;
    padding: 0.6rem;
  }
  .social-icon-linkin {
    width: 2.2rem;
    height: 2.2rem;
    padding: 0.8rem;
  }
  .social-icon-twitter {
    width: 2.2rem;
    height: 2.2rem;
    padding: 0.8rem;
  }
  .social-icon-line {
    width: 3.9rem;
    height: 3.9rem;
  }
  .social-icon-wechat {
    width: 2.6rem;
    height: 2.6rem;
    padding: 0.6rem;
  }
  .social-icon-whatsapp {
    width: 2.6rem;
    height: 2.6rem;
    padding: 0.6rem;
  }
  .social-icon-kakao {
    width: 3.9rem;
    height: 3.9rem;
  }
  .image-icon {
    margin-right: 12%;
    margin-top: -4rem;
  }
}
</style>